export enum VenueType {
  VENUE_RESTAURANT = 'VENUE_RESTAURANT',

  VENUE_RESTAURANT_HOTEL = 'VENUE_RESTAURANT_HOTEL',

  VENUE_HOTEL = 'VENUE_HOTEL',
}
